exports.onRouteUpdateDelayed = ({ action, location }) => {
	// fire event to trigger loading spinner
	const event = new CustomEvent('pageLoadingDelayed', { action, location })
	document.dispatchEvent(event)
}

exports.onRouteUpdate = ({ action, location }) => {
	// fire event to say loading is complete
	const event = new CustomEvent('pageLoadComplete', { action, location })
	document.dispatchEvent(event)
}
